// Production mode: renders the real Jotform booking form once the owner
// creates it and sets REACT_APP_JOTFORM_BOOKING_URL. Kept intentionally thin —
// the final embed method (iframe / script / popup) is decided when the actual
// Jotform exists.
export const JotformEmbed = ({ url }) => (
  <div
    className="mx-auto max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-coal"
    data-testid="jotform-embed"
  >
    <iframe
      src={url}
      title="HairByYaya booking form"
      className="h-[80vh] w-full bg-white"
      allow="geolocation; microphone; camera"
    />
    <p className="p-4 text-center text-xs text-white/40">
      Booking powered by Jotform.{" "}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-hotpink underline"
      >
        Open in a new tab
      </a>
    </p>
  </div>
);

